import Head from "next/head"
import React from "react"
import styled from "styled-components"

import { Container } from "~/components/Container"
import { Markdown } from "~/components/Markdown"
import { distributionTitle } from "~/config"
import { TrackingProvider } from "~/contexts/Tracking"
import { color } from "~/libs/style"
import { Notice } from "~/repository/NoticeCatalogsRepository"

import { Header } from "../Header"
import { PaidFooter } from "../PaidFooter/PaidFooter"
import { ToTopButton } from "../ToTopButton/ToTopButton"
type NoticeProps = {
  notice: Notice
  distribution: string
  configDomain: {
    top: string
    paid: string
    free: string
  }
}

export const PaidNotice: React.FC<NoticeProps> = (props) => {
  const { notice, configDomain } = props
  const title = distributionTitle
  return (
    <>
      <Head>
        <link rel="canonical" href={`/gachi/notices/${notice.id}.html`} />
        <title>{notice.title} - イージーゲーム|au Webポータル</title>
        <meta name="robots" content="noindex" />
        <meta name="description" content="イージーゲーム（人気ガチ）お知らせ" />
        <meta name="apple-mobile-web-app-title" content="イージーゲーム（人気ガチ）お知らせ"></meta>
        <link rel="canonical" href="https://games.portal.auone.jp/gachi/" />
        {/* Fluct用 */}
        <link rel="preload" as="script" href="https://pdn.adingo.jp/p.js" />
        <link rel="preconnect" href="https://sh.adingo.jp" crossOrigin="use-credentials" />
      </Head>
      <TrackingProvider categoryProp="お知らせ">
        <Container>
          <Header hasBackButton={true} backTitle={title} headerTitle={title} backUrl={configDomain.paid} />

          <Headline>
            <TextGroup>
              <Title>{notice.title}</Title>
              <LastUpdate>{notice.lastUpdate}</LastUpdate>
            </TextGroup>
          </Headline>
          <Markdown source={notice.body} />
        </Container>
        <PaidFooter />
        <ToTopButton />
      </TrackingProvider>
    </>
  )
}
const Headline = styled.div`
  margin-bottom: 10px;
  line-height: 1.3;
`

const TextGroup = styled.div`
  padding: 10px;
`

const Title = styled.h1`
  font-size: 18px;
  font-weight: bold;
`

const LastUpdate = styled.p`
  margin-top: 10px;
  color: ${color.silverGray};
  font-size: 12px;
  line-height: 1.2;
  text-align: right;
`
